import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Demo from "./Demo";
import Tab from "./demo/tab/Tab";

const App = () => {
  const routes = createBrowserRouter([
    {
      path: "/",
      element: <Navigate to="/demo" replace />,
    },
    {
      path: "demo",
      element: <Tab />,
    },
  ]);

  return (
    <div>
      <RouterProvider router={routes} />
    </div>
  );
};

export default App;
